import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { KhodroHttpGetService } from '../Services/KhodroHttpService';

export const getActiveTaahodSalesJaani = createAsyncThunk('TaahodSalesJaani/GetActiveTaahodSalesJaani', async () => {
  return await KhodroHttpGetService({
    url: `${_apiPathManagerConfig?.Khodro.TaahodSalesJaani.GetActiveTaahodSalesJaani}`,
  });
});
